(() => {
  if (window.__mmaDecisionUxV13 === true) return;
  window.__mmaDecisionUxV13 = true;

  const GA4_MEASUREMENT_ID = "G-PKHVJ3LX7Z";
  const META_PIXEL_ID = "578895468205709";
  const TRACKING_VERSION = "mma_decision_20260724_v13";
  const META_EVENT_NAMES = Object.freeze({
    mma_pdp_decision_view: "MMAPDPDecisionView",
    mma_pdp_decision_click: "MMAPDPDecisionClick",
    mma_glove_finder_view: "MMAFinderView",
    mma_glove_finder_start: "MMAFinderStart",
    mma_glove_finder_answer: "MMAFinderStep",
    mma_glove_finder_complete: "MMAFinderComplete",
    mma_glove_finder_refine: "MMAFinderRefine",
    mma_glove_finder_cta_click: "MMAFinderCTA",
  });
  const pendingViews = new Map();
  const deliveredViews = new Set();
  const observedViews = new WeakSet();

  const compact = (input) => {
    const output = {};
    Object.keys(input || {}).forEach((key) => {
      const value = input[key];
      if (value !== undefined && value !== null && value !== "") {
        output[key] = value;
      }
    });
    return output;
  };

  const normalizeText = (value, limit = 100) =>
    String(value || "").replace(/\s+/g, " ").trim().slice(0, limit);

  const analyticsStatus = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (
        privacy &&
        typeof privacy.analyticsProcessingAllowed === "function"
      ) {
        return privacy.analyticsProcessingAllowed();
      }
    } catch (error) {
      return false;
    }
    // Match the storefront's established size-guide and Trustpilot tracking
    // contract: if Shopify does not expose the privacy API, analytics remains
    // available. When the API exists, its explicit true/false decision wins.
    return true;
  };

  const analyticsAllowed = () => analyticsStatus() === true;

  const marketingStatus = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === "function") {
        return privacy.marketingAllowed();
      }
    } catch (error) {
      return false;
    }
    return null;
  };

  const marketingAllowed = () => marketingStatus() === true;

  const getCookie = (name) => {
    const prefix = `${name}=`;
    const item = document.cookie
      .split("; ")
      .find((cookie) => cookie.indexOf(prefix) === 0);
    return item ? decodeURIComponent(item.slice(prefix.length)) : "";
  };

  const sessionValue = (key, factory) => {
    try {
      const stored = window.sessionStorage.getItem(key);
      if (stored) return stored;
      const value = factory();
      window.sessionStorage.setItem(key, value);
      return value;
    } catch (error) {
      return factory();
    }
  };

  const gaClientId = () => {
    const gaCookie = getCookie("_ga");
    const parts = gaCookie.split(".");
    if (parts.length >= 4) return parts.slice(-2).join(".");
    return sessionValue(
      "mma_decision_ga_cid",
      () =>
        `${Math.floor(Math.random() * 2147483647)}.${Math.floor(
          Date.now() / 1000
        )}`
    );
  };

  const gaSessionId = () => {
    const cookieName = `_ga_${GA4_MEASUREMENT_ID.replace("G-", "")}`;
    const value = getCookie(cookieName);
    const gs2 = value.match(/(?:^|\$)s(\d+)(?:\$|$)/);
    if (gs2) return gs2[1];
    const gs1 = value.match(/^GS\d+\.\d+\.(\d+)(?:\.|$)/);
    if (gs1) return gs1[1];
    return sessionValue("mma_decision_ga_sid", () =>
      String(Math.floor(Date.now() / 1000))
    );
  };

  const sendGa4Direct = (name, payload) => {
    const query = new URLSearchParams({
      v: "2",
      tid: GA4_MEASUREMENT_ID,
      cid: gaClientId(),
      en: name,
      _p: String(Date.now()),
      dl: window.location.href,
      dt: document.title,
      sr: `${window.screen.width}x${window.screen.height}`,
      ul: (navigator.language || "en-us").toLowerCase(),
      sid: gaSessionId(),
      sct: "1",
      seg: "1",
    });

    Object.keys(payload).forEach((key) => {
      const value = payload[key];
      query.set(`${typeof value === "number" ? "epn" : "ep"}.${key}`, value);
    });

    const endpoint = `https://region1.analytics.google.com/g/collect?${query}`;
    let sent = false;
    try {
      sent =
        typeof navigator.sendBeacon === "function" &&
        navigator.sendBeacon(endpoint, "");
    } catch (error) {
      sent = false;
    }
    if (!sent && typeof window.fetch === "function") {
      window
        .fetch(endpoint, {
          method: "POST",
          mode: "no-cors",
          keepalive: true,
        })
        .catch(() => {});
    }
  };

  const sendGa4 = (name, payload) => {
    if (!analyticsAllowed()) return;
    try {
      if (typeof window.gtag === "function") {
        window.gtag(
          "event",
          name,
          Object.assign({ send_to: GA4_MEASUREMENT_ID }, payload)
        );
        return;
      }
    } catch (error) {
      // Continue through the same consent-aware direct transport used elsewhere.
    }
    sendGa4Direct(name, payload);
  };

  const sendTripleWhale = (name, payload) => {
    if (!analyticsAllowed()) return false;
    try {
      if (typeof window.TriplePixel === "function") {
        window.TriplePixel("custom", name, payload);
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };

  const ensureMetaPixel = () => {
    if (typeof window.fbq !== "function") {
      const fbq = function () {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, arguments);
        } else {
          fbq.queue.push(arguments);
        }
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = "2.0";
      fbq.queue = [];
      window.fbq = fbq;

      const script = document.createElement("script");
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      const firstScript = document.getElementsByTagName("script")[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }

    if (window.__mmaMetaPixelInitialized !== META_PIXEL_ID) {
      window.fbq("init", META_PIXEL_ID);
      window.__mmaMetaPixelInitialized = META_PIXEL_ID;
    }
  };

  const sendMeta = (name, payload) => {
    const metaEvent = META_EVENT_NAMES[name];
    if (!metaEvent || !marketingAllowed()) return false;
    try {
      ensureMetaPixel();
      window.fbq("trackCustom", metaEvent, payload);
      return true;
    } catch (error) {
      return false;
    }
  };

  const publishShopify = (name, payload) => {
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === "function"
      ) {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (error) {
      // GA4 and Triple Whale remain the primary reporting destinations.
    }
  };

  const eventKey = (name, payload) =>
    [
      name,
      payload.page_path || window.location.pathname,
      payload.surface || "",
      payload.product_handle || "",
      payload.result_handle || "",
      payload.result_stage || "",
    ].join("|");

  const deliver = (name, payload) => {
    const key = eventKey(name, payload);
    if (name.endsWith("_view")) {
      if (deliveredViews.has(key)) return;
      deliveredViews.add(key);
    }
    sendGa4(name, payload);
    if (!sendTripleWhale(name, payload)) {
      window.setTimeout(() => sendTripleWhale(name, payload), 1500);
    }
    sendMeta(name, payload);
    publishShopify(name, payload);
  };

  const isDebugMode = () => {
    const query = new URLSearchParams(window.location.search);
    return (
      query.get("mma_decision_debug") === "1" ||
      query.get("_qa") === "mma-decision-v12" ||
      query.get("_qa") === "mma-decision-v13"
    );
  };

  const recordDebug = (root, name, payload) => {
    const detail = Object.assign(
      {
        event: name,
        analytics_allowed: analyticsStatus(),
        marketing_allowed: marketingStatus(),
        ga_transport: typeof window.gtag === "function" ? "gtag" : "direct",
        triple_whale_available: typeof window.TriplePixel === "function",
        meta_pixel_available: typeof window.fbq === "function",
      },
      payload
    );
    document.dispatchEvent(
      new CustomEvent("mma:decision-analytics", { detail })
    );
    if (isDebugMode() && root) {
      root.setAttribute("data-mma-last-event", JSON.stringify(detail));
      let history = [];
      try {
        history = JSON.parse(root.getAttribute("data-mma-event-sequence") || "[]");
      } catch (error) {
        history = [];
      }
      history.push(detail);
      root.setAttribute(
        "data-mma-event-sequence",
        JSON.stringify(history.slice(-30))
      );
    }
  };

  const publish = (name, payload, root, attempt = 0) => {
    const cleanPayload = compact(payload);
    if (attempt === 0) recordDebug(root, name, cleanPayload);

    const status = analyticsStatus();
    if (status === null && attempt < 12) {
      window.setTimeout(
        () => publish(name, cleanPayload, root, attempt + 1),
        250
      );
      return;
    }
    if (status !== true) {
      if (name.endsWith("_view")) {
        pendingViews.set(eventKey(name, cleanPayload), {
          name,
          payload: cleanPayload,
        });
      }
      return;
    }
    deliver(name, cleanPayload);
  };

  const flushPendingViews = () => {
    if (!analyticsAllowed()) return;
    pendingViews.forEach(({ name, payload }) => deliver(name, payload));
    pendingViews.clear();
  };

  const trackVisible = (root, name, payload) => {
    if (!root || observedViews.has(root)) return;
    observedViews.add(root);
    if (!("IntersectionObserver" in window)) {
      publish(name, payload, root);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        publish(name, payload, root);
      },
      { threshold: 0.35 }
    );
    observer.observe(root);
  };

  const interactionMethod = (event) =>
    event && event.detail === 0 ? "keyboard" : "pointer";

  const componentPayload = (component, surface) => ({
    surface,
    product_handle: normalizeText(component.dataset.mmaProductHandle),
    product_title: normalizeText(component.dataset.mmaProductTitle),
    product_brand: normalizeText(component.dataset.mmaProductBrand),
    page_path: window.location.pathname,
    tracking_version:
      component.dataset.mmaTrackingVersion || TRACKING_VERSION,
  });

  const initializeModelFaqs = (component) => {
    const productMain = component.closest(".product-main");
    const faqDetails = productMain
      ? [
          ...productMain.querySelectorAll(
            ".product-block__collapsible_tab details"
          ),
        ].slice(0, 3)
      : [];

    faqDetails.forEach((details, index) => {
      const faqNumber = index + 1;
      const question = component.getAttribute(
        `data-mma-faq-${faqNumber}-question`
      );
      const answer = component.getAttribute(
        `data-mma-faq-${faqNumber}-answer`
      );
      const summaryLabel = details.querySelector("summary > span");
      const content = details.querySelector(".content.rte");
      if (!question || !answer || !summaryLabel || !content) return;

      [...summaryLabel.childNodes].forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) node.remove();
      });
      summaryLabel.append(document.createTextNode(question));

      const paragraph = document.createElement("p");
      paragraph.textContent = answer;
      content.replaceChildren(paragraph);
      details.dataset.mmaModelFaq = String(faqNumber);
    });
  };

  const initializeDecisionHelper = (component) => {
    if (component.dataset.mmaDecisionBound === "true") return;
    component.dataset.mmaDecisionBound = "true";
    component
      .closest(".product-block")
      ?.classList.add("product-block--mma-glove-fit");

    initializeModelFaqs(component);
    const surface =
      component.hasAttribute("data-mma-shin-fit")
        ? "shin_fit_helper"
        : "glove_fit_helper";
    const basePayload = componentPayload(component, surface);
    trackVisible(
      component,
      "mma_pdp_decision_view",
      Object.assign({}, basePayload, { cue_count: 5 })
    );

    const triggers = [
      ...component.querySelectorAll("[data-mma-fit-trigger]"),
    ];
    const closeAll = (except) => {
      triggers.forEach((trigger) => {
        if (trigger !== except) trigger.setAttribute("aria-expanded", "false");
      });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        const shouldOpen = trigger.getAttribute("aria-expanded") !== "true";
        closeAll(trigger);
        trigger.setAttribute("aria-expanded", String(shouldOpen));
        trigger.classList.toggle("is-tooltip-suppressed", !shouldOpen);
        publish(
          "mma_pdp_decision_click",
          Object.assign({}, basePayload, {
            action: shouldOpen ? "cue_open" : "cue_close",
            cue_key: normalizeText(trigger.dataset.mmaCueKey),
            cue_status: normalizeText(trigger.dataset.mmaCueStatus),
            cue_tone: normalizeText(trigger.dataset.mmaCueTone),
            interaction_method: interactionMethod(event),
          }),
          component
        );
      });

      trigger.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          trigger.setAttribute("aria-expanded", "false");
          trigger.classList.add("is-tooltip-suppressed");
          trigger.focus();
        }
      });

      trigger.addEventListener("blur", () => {
        trigger.classList.remove("is-tooltip-suppressed");
      });
    });

    component
      .querySelector("[data-mma-better-route]")
      ?.addEventListener("click", (event) => {
        const link = event.currentTarget;
        publish(
          "mma_pdp_decision_click",
          Object.assign({}, basePayload, {
            action: "better_route",
            target_handle: normalizeText(link.dataset.mmaTargetHandle),
            interaction_method: interactionMethod(event),
          }),
          component
        );
      });

    document.addEventListener("click", (event) => {
      if (!component.contains(event.target)) closeAll();
    });
  };

  const initializeModelGuide = (guide) => {
    if (guide.dataset.mmaGuideBound === "true") return;
    guide.dataset.mmaGuideBound = "true";
    const basePayload = componentPayload(guide, "model_guide");
    trackVisible(
      guide,
      "mma_pdp_decision_view",
      Object.assign({}, basePayload, { model_count: 4 })
    );

    guide.querySelectorAll("[data-mma-model-action]").forEach((card) => {
      card.addEventListener("click", (event) => {
        publish(
          "mma_pdp_decision_click",
          Object.assign({}, basePayload, {
            action: normalizeText(card.dataset.mmaModelAction),
            target_handle: normalizeText(card.dataset.mmaProductHandle),
            model_position: Number(card.dataset.mmaModelPosition || 0),
            interaction_method: interactionMethod(event),
          }),
          guide
        );

        if (!card.hasAttribute("data-mma-current-product-cta")) return;
        const page = card.closest("main") || document;
        const buyButton =
          page.querySelector(
            '.product-main .product-block__buy_buttons button[name="add"]'
          ) ||
          page.querySelector(
            '.product-main .product-form__buttons button[name="add"]'
          );
        if (!buyButton) return;
        const buybox =
          buyButton.closest(".product-block__buy_buttons") ||
          buyButton.closest(".product-form__buttons") ||
          buyButton;
        buybox.scrollIntoView({ behavior: "smooth", block: "center" });
        if (!buyButton.disabled) {
          window.setTimeout(() => {
            buyButton.focus({ preventScroll: true });
          }, 450);
        }
      });
    });
  };

  const initializeFinder = (finder) => {
    if (finder.dataset.mmaFinderBound === "true") return;
    finder.dataset.mmaFinderBound = "true";

    const steps = [...finder.querySelectorAll("[data-finder-step]")];
    const result = finder.querySelector("[data-finder-result]");
    const answers = {};
    const answerLabels = {};
    const progressItems = [
      ...finder.querySelectorAll("[data-finder-progress-step]"),
    ];
    const basePayload = {
      surface: "glove_finder",
      page_path: window.location.pathname,
      tracking_version:
        finder.dataset.mmaTrackingVersion || TRACKING_VERSION,
    };
    const productData = [
      ...finder.querySelectorAll("[data-finder-product]"),
    ].reduce((index, node) => {
      index[node.dataset.handle] = {
        handle: node.dataset.handle,
        title: node.dataset.title,
        image: node.dataset.image,
        url: node.dataset.url,
        available: node.dataset.available === "true",
        reason: node.dataset.reason,
        tradeoff: node.dataset.tradeoff,
      };
      return index;
    }, {});
    const productTraits = {
      "fairtex-bgv1-boxing-gloves": {
        label: "COMPACT ALL-ROUND FIT",
        copy: "Prioritize mixed training with a compact hand compartment.",
      },
      "fairtex-bgv9-mexican-style-boxing-gloves": {
        label: "DENSER BAG FEEDBACK",
        copy: "Prioritize a firmer, more direct bag and pad route.",
      },
      "fairtex-bgv14-microfiber-gloves": {
        label: "LIGHTER EASY-CARE SHELL",
        copy: "Prioritize a lighter microfiber general-training route.",
      },
      "fairtex-bgv11-f-day-boxing-gloves": {
        label: "ROOMIER + SOFTER FAIRTEX FIT",
        copy: "Prioritize more hand and finger room with softer padding.",
      },
      "fairtex-bgv19-deluxe-tight-fit-boxing-gloves": {
        label: "TIGHTER + EXTRA-PADDED FIT",
        copy: "Prioritize a deliberately tight fit with extra knuckle padding.",
      },
      "twins-special-bgvl3-boxing-gloves": {
        label: "SOFTER SPARRING FEEL",
        copy: "Prioritize a pillowy, protection-oriented training feel.",
      },
      "yokkao-essential-boxing-gloves": {
        label: "LOWER ENTRY PRICE",
        copy: "Keep the practical first-glove or general-training route.",
      },
      "yokkao-matrix-boxing-gloves": {
        label: "PREMIUM COWHIDE BUILD",
        copy: "Prioritize Thai-made cowhide construction.",
      },
    };
    let resultState = null;
    let finderStarted = false;
    let finderCompleted = false;

    trackVisible(
      finder,
      "mma_glove_finder_view",
      Object.assign({}, basePayload, { funnel_stage: "view" })
    );

    const answerPayload = () => ({
      training_job: answers.goal,
      wrapped_hand_fit: answers.fit,
      feel_priority: answers.priority,
    });

    const routeCandidates = () => {
      const { goal, fit, priority } = answers;
      const routes = {
        mixed: {
          crisp: [
            "fairtex-bgv1-boxing-gloves",
            "fairtex-bgv9-mexican-style-boxing-gloves",
          ],
          protective: [
            "twins-special-bgvl3-boxing-gloves",
            "fairtex-bgv11-f-day-boxing-gloves",
          ],
          premium: [
            "yokkao-matrix-boxing-gloves",
            "fairtex-bgv1-boxing-gloves",
          ],
          value: [
            "yokkao-essential-boxing-gloves",
            "fairtex-bgv14-microfiber-gloves",
          ],
        },
        bag_pads: {
          crisp: [
            "fairtex-bgv9-mexican-style-boxing-gloves",
            "fairtex-bgv1-boxing-gloves",
          ],
          protective: [
            "fairtex-bgv1-boxing-gloves",
            "fairtex-bgv9-mexican-style-boxing-gloves",
          ],
          premium: [
            "fairtex-bgv9-mexican-style-boxing-gloves",
            "yokkao-matrix-boxing-gloves",
          ],
          value: [
            "fairtex-bgv9-mexican-style-boxing-gloves",
            "yokkao-essential-boxing-gloves",
          ],
        },
        sparring: {
          crisp: [
            "twins-special-bgvl3-boxing-gloves",
            "fairtex-bgv1-boxing-gloves",
          ],
          protective: [
            "twins-special-bgvl3-boxing-gloves",
            "fairtex-bgv11-f-day-boxing-gloves",
          ],
          premium: [
            "twins-special-bgvl3-boxing-gloves",
            "yokkao-matrix-boxing-gloves",
          ],
          value: [
            "twins-special-bgvl3-boxing-gloves",
            "yokkao-essential-boxing-gloves",
          ],
        },
      };
      const needsRoomRoutes = {
        mixed: {
          crisp: [
            "fairtex-bgv11-f-day-boxing-gloves",
            "fairtex-bgv9-mexican-style-boxing-gloves",
          ],
          protective: [
            "fairtex-bgv11-f-day-boxing-gloves",
            "twins-special-bgvl3-boxing-gloves",
          ],
          premium: [
            "yokkao-matrix-boxing-gloves",
            "fairtex-bgv11-f-day-boxing-gloves",
          ],
          value: [
            "yokkao-essential-boxing-gloves",
            "fairtex-bgv14-microfiber-gloves",
          ],
        },
        bag_pads: {
          crisp: [
            "fairtex-bgv9-mexican-style-boxing-gloves",
            "fairtex-bgv11-f-day-boxing-gloves",
          ],
          protective: [
            "fairtex-bgv11-f-day-boxing-gloves",
            "fairtex-bgv9-mexican-style-boxing-gloves",
          ],
          premium: [
            "fairtex-bgv9-mexican-style-boxing-gloves",
            "yokkao-matrix-boxing-gloves",
          ],
          value: [
            "fairtex-bgv9-mexican-style-boxing-gloves",
            "yokkao-essential-boxing-gloves",
          ],
        },
        sparring: {
          crisp: [
            "twins-special-bgvl3-boxing-gloves",
            "fairtex-bgv11-f-day-boxing-gloves",
          ],
          protective: [
            "fairtex-bgv11-f-day-boxing-gloves",
            "twins-special-bgvl3-boxing-gloves",
          ],
          premium: [
            "twins-special-bgvl3-boxing-gloves",
            "fairtex-bgv11-f-day-boxing-gloves",
          ],
          value: [
            "twins-special-bgvl3-boxing-gloves",
            "yokkao-essential-boxing-gloves",
          ],
        },
      };
      const activeRoutes = fit === "tight" ? needsRoomRoutes : routes;
      let ranked = [
        ...(activeRoutes[goal]?.[priority] || activeRoutes.mixed.crisp),
      ];

      // BGV19 is a narrow answer, not a general upgrade. It appears only as
      // the final tradeoff for buyers who explicitly accept a snug fit and
      // prioritize sharper mixed-training or bag-and-pad feedback.
      if (fit === "no_issue" && priority === "crisp" && goal === "mixed") {
        ranked = [
          "fairtex-bgv1-boxing-gloves",
          "fairtex-bgv19-deluxe-tight-fit-boxing-gloves",
        ];
      } else if (
        fit === "no_issue" &&
        priority === "crisp" &&
        goal === "bag_pads"
      ) {
        ranked = [
          "fairtex-bgv9-mexican-style-boxing-gloves",
          "fairtex-bgv19-deluxe-tight-fit-boxing-gloves",
        ];
      }

      ranked = [...new Set(ranked)].filter((handle) => productData[handle]);
      ranked.sort(
        (a, b) =>
          Number(productData[b].available) -
          Number(productData[a].available)
      );
      return ranked;
    };

    const updateProgress = (stepNumber, complete = false) => {
      progressItems.forEach((item, index) => {
        const itemNumber = index + 1;
        const isActive = !complete && itemNumber === stepNumber;
        item.classList.toggle("is-active", isActive);
        item.classList.toggle(
          "is-complete",
          complete || itemNumber < stepNumber
        );
        if (isActive) {
          item.setAttribute("aria-current", "step");
        } else {
          item.removeAttribute("aria-current");
        }
      });
    };

    const showStep = (index) => {
      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== index;
      });
      result.hidden = true;
      updateProgress(index + 1);
      steps[index]?.querySelector("[data-finder-answer]")?.focus({
        preventScroll: true,
      });
    };

    const renderProduct = (product, stage, refinementChoice = "") => {
      const image = result.querySelector("[data-result-image]");
      image.src = product.image;
      image.alt = product.title;
      result.querySelector("[data-result-label]").textContent =
        stage === "refined"
          ? "UPDATED RECOMMENDATION"
          : "YOUR RECOMMENDATION";
      result.querySelector("[data-result-title]").textContent =
        stage === "refined"
          ? `GO WITH ${product.title}`
          : `START WITH ${product.title}`;
      result.querySelector("[data-result-reason]").textContent = product.reason;

      const fitNote =
        answers.fit === "tight"
          ? " This result avoids our known compact-fit route. Check the size guide with your usual wraps because fit can still vary by ounce."
          : answers.fit === "not_sure"
            ? " Fit can vary by hand, wraps and ounce. Check the size guide before ordering."
            : "";
      result.querySelector("[data-result-tradeoff]").textContent =
        `${product.tradeoff}${fitNote}`;

      const availability = result.querySelector(
        "[data-result-availability]"
      );
      availability.dataset.available = String(product.available);
      availability.textContent = product.available
        ? "IN-STOCK OPTIONS AVAILABLE"
        : "TEMPORARILY OUT OF STOCK";

      const cta = result.querySelector("[data-result-link]");
      cta.href = product.url;
      cta.textContent = `SHOP ${product.title}`;
      cta.dataset.resultHandle = product.handle;
      cta.dataset.resultStage = stage;

      resultState.selected = product;
      resultState.stage = stage;
      resultState.refinementChoice = refinementChoice;
    };

    const setRefinementSelection = (choice, selectedTitle) => {
      const selectedChoice = choice === "switch" ? "switch" : "keep";
      result
        .querySelectorAll("[data-refine-choice]")
        .forEach((button) => {
          const isSelected =
            button.dataset.refineChoice === selectedChoice;
          button.classList.toggle("is-selected", isSelected);
          button.setAttribute(
            "aria-pressed",
            isSelected ? "true" : "false"
          );
          const state = button.querySelector("[data-refine-state]");
          if (state) {
            state.textContent = isSelected
              ? "CURRENT MATCH"
              : "SWITCH TO";
          }
        });
      result.querySelector(
        "[data-refine-confirmation]"
      ).textContent = `CURRENT MATCH: ${selectedTitle}`;
    };

    const configureRefinement = (primary, alternative) => {
      const refine = result.querySelector("[data-result-refine]");
      if (!alternative) {
        refine.hidden = true;
        return;
      }
      refine.hidden = false;
      const primaryTrait = productTraits[primary.handle];
      const alternativeTrait = productTraits[alternative.handle];
      result.querySelector("[data-refine-question]").textContent =
        "WHICH FINAL TRADEOFF MATTERS MORE?";
      result.querySelector("[data-refine-keep-label]").textContent =
        primaryTrait.label;
      result.querySelector("[data-refine-keep-copy]").textContent =
        primaryTrait.copy;
      result.querySelector("[data-refine-switch-label]").textContent =
        alternativeTrait.label;
      result.querySelector("[data-refine-switch-copy]").textContent =
        alternativeTrait.copy;
      setRefinementSelection("keep", primary.title);
    };

    const trackResult = (product, stage, refinementChoice = "") => {
      publish(
        "mma_glove_finder_result",
        Object.assign({}, basePayload, answerPayload(), {
          result_handle: product.handle,
          result_title: product.title,
          result_available: product.available ? 1 : 0,
          result_stage: stage,
          refinement_choice: refinementChoice,
        }),
        finder
      );
    };

    const renderResult = () => {
      const ranked = routeCandidates();
      const primary = productData[ranked[0]];
      const alternative = productData[ranked[1]];
      if (!primary) return;
      resultState = {
        primary,
        alternative,
        selected: primary,
        stage: "initial",
        refinementChoice: "",
      };

      const answerSummary = result.querySelector("[data-result-answers]");
      answerSummary.replaceChildren(
        ...["goal", "fit", "priority"].map((key) => {
          const chip = document.createElement("span");
          chip.textContent = answerLabels[key];
          return chip;
        })
      );
      renderProduct(primary, "initial");
      configureRefinement(primary, alternative);
      steps.forEach((step) => {
        step.hidden = true;
      });
      result.hidden = false;
      updateProgress(3, true);
      const reducedMotion =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      result.scrollIntoView({
        behavior: reducedMotion ? "auto" : "smooth",
        block: "start",
      });
      trackResult(primary, "initial");
      if (!finderCompleted) {
        finderCompleted = true;
        publish(
          "mma_glove_finder_complete",
          Object.assign({}, basePayload, answerPayload(), {
            funnel_stage: "complete",
            result_handle: primary.handle,
            result_title: primary.title,
            result_available: primary.available ? 1 : 0,
            result_stage: "initial",
          }),
          finder
        );
      }
    };

    finder.querySelectorAll("[data-finder-answer]").forEach((button) => {
      button.setAttribute("aria-pressed", "false");
      button.addEventListener("click", (event) => {
        const step = button.closest("[data-finder-step]");
        step.querySelectorAll("[data-finder-answer]").forEach((option) => {
          option.classList.toggle("is-selected", option === button);
          option.setAttribute(
            "aria-pressed",
            option === button ? "true" : "false"
          );
        });
        answers[button.dataset.answerKey] = button.dataset.answerValue;
        answerLabels[button.dataset.answerKey] = button.dataset.answerLabel;
        const current = Number(step.dataset.finderStep);
        if (!finderStarted) {
          finderStarted = true;
          publish(
            "mma_glove_finder_start",
            Object.assign({}, basePayload, {
              funnel_stage: "start",
              start_step: current,
              interaction_method: interactionMethod(event),
            }),
            finder
          );
        }
        publish(
          "mma_glove_finder_answer",
          Object.assign({}, basePayload, {
            funnel_stage: `step_${current}`,
            step: current,
            answer_key: normalizeText(button.dataset.answerKey),
            answer_value: normalizeText(button.dataset.answerValue),
            answer_label: normalizeText(button.dataset.answerLabel),
            interaction_method: interactionMethod(event),
          }),
          finder
        );
        if (current < steps.length) {
          showStep(current);
        } else {
          renderResult();
        }
      });
    });

    finder.querySelectorAll("[data-finder-back]").forEach((button) => {
      button.addEventListener("click", () => {
        const current = Number(
          button.closest("[data-finder-step]").dataset.finderStep
        );
        publish(
          "mma_glove_finder_back",
          Object.assign({}, basePayload, { from_step: current }),
          finder
        );
        showStep(Math.max(0, current - 2));
      });
    });

    finder.querySelectorAll("[data-refine-choice]").forEach((button) => {
      button.setAttribute("aria-pressed", "false");
      button.addEventListener("click", (event) => {
        if (!resultState) return;
        const choice = button.dataset.refineChoice;
        const selected =
          choice === "switch" && resultState.alternative
            ? resultState.alternative
            : resultState.primary;
        setRefinementSelection(choice, selected.title);
        renderProduct(selected, "refined", choice);
        trackResult(selected, "refined", choice);
        publish(
          "mma_glove_finder_refine",
          Object.assign({}, basePayload, answerPayload(), {
            result_handle: selected.handle,
            refinement_choice: choice,
            interaction_method: interactionMethod(event),
          }),
          finder
        );
      });
    });

    finder
      .querySelector("[data-result-link]")
      ?.addEventListener("click", (event) => {
        if (!resultState) return;
        publish(
          "mma_glove_finder_product_click",
          Object.assign({}, basePayload, answerPayload(), {
            result_handle: resultState.selected.handle,
            result_stage: resultState.stage,
            refinement_choice: resultState.refinementChoice,
            interaction_method: interactionMethod(event),
          }),
          finder
        );
        publish(
          "mma_glove_finder_cta_click",
          Object.assign({}, basePayload, answerPayload(), {
            funnel_stage: "cta",
            result_handle: resultState.selected.handle,
            result_title: resultState.selected.title,
            result_available: resultState.selected.available ? 1 : 0,
            result_stage: resultState.stage,
            refinement_choice: resultState.refinementChoice,
            destination_path: resultState.selected.url.split("?")[0],
            interaction_method: interactionMethod(event),
          }),
          finder
        );
      });

    finder
      .querySelector("[data-finder-restart]")
      ?.addEventListener("click", () => {
        publish(
          "mma_glove_finder_restart",
          Object.assign({}, basePayload, answerPayload(), {
            result_handle: resultState?.selected?.handle,
            result_stage: resultState?.stage,
          }),
          finder
        );
        Object.keys(answers).forEach((key) => delete answers[key]);
        Object.keys(answerLabels).forEach((key) => delete answerLabels[key]);
        resultState = null;
        finderStarted = false;
        finderCompleted = false;
        finder.querySelectorAll("[data-finder-answer]").forEach((option) => {
          option.classList.remove("is-selected");
          option.setAttribute("aria-pressed", "false");
        });
        showStep(0);
        finder.scrollIntoView({ behavior: "smooth", block: "start" });
      });
  };

  const ready = () => {
    document
      .querySelectorAll("[data-mma-glove-fit]")
      .forEach(initializeDecisionHelper);
    document
      .querySelectorAll("[data-mma-model-guide]")
      .forEach(initializeModelGuide);
    document
      .querySelectorAll("[data-mma-glove-finder]")
      .forEach(initializeFinder);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready, { once: true });
  } else {
    ready();
  }
  document.addEventListener("visitorConsentCollected", flushPendingViews);
})();
